import { connect } from 'react-redux';
import SupportingDocsPage from './SupportingDocsPage';
import {
  isFetching,
  getError,
  hasAllRequiredDocuments,
} from '../../../state/reducers/ApplicationReducer';
import ConfigActions from '../../../state/actions/ConfigActions';
import { isLoaded } from '../../../state/reducers/ConfigReducer';

const { getConfigRequest } = ConfigActions;

export default connect(
  (state) => ({
    isFetching: isFetching(state),
    isLoaded: isLoaded(state),
    error: !!getError(state),
    hasAllRequiredDocuments: hasAllRequiredDocuments(state),
  }),
  {
    loadData: getConfigRequest,
  }
)(SupportingDocsPage);



// WEBPACK FOOTER //
// ./src/view/scenes/SupportingDocs/index.js